import ConfigManager from "@/config/ConfigManager"
import BzbsApi from "@/core/Http/BzbsApi"

export const useBlob = function () {
    const loadAppConfig = function (url) {
        let baseUrl = ConfigManager.getBlobUrl() + "/apps/" + ConfigManager.getAppId()

        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGetBlob(baseUrl + url).subscribe({
                next: (res) => {
                    resolve(res.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }

    return {
        loadAppConfig
    }
}